export default "__VITE_ASSET__62c536ff__"